import { useContext, useState } from 'react';
import { apiPostRequest } from 'src/utils/mlPigeonAPIRequest';
import { ToastMessageContext } from 'src/context/toastMessageContext';
export interface ApprovalConfig {
  flowId: string;
  operatorName: string;
  statusMessage: string;
  decision: string;
}

export const useApprovalDecision = (): [
  boolean,
  (
    { flowId, operatorName, statusMessage, decision }: ApprovalConfig,
    successCallback?: () => void,
  ) => void,
] => {
  const [loading, setLoading] = useState<boolean>(false);
  const { addToastMessage } = useContext(ToastMessageContext);

  const sendApprovalDecision = (
    { flowId, operatorName, statusMessage, decision }: ApprovalConfig,
    successCallback?: () => void,
  ) => {
    setLoading(true);
    const approvalTriggerDetails = {
      operatorFlowJobId: flowId,
      operatorName,
      statusMessage,
      newStatus: decision,
    };
    apiPostRequest({
      endpoint: 'approvalOperatorStatus',
      data: approvalTriggerDetails,
    })
      .then(() => {
        successCallback?.();
        addToastMessage({
          header: 'Request Submitted Successfully',
          description:
            approvalTriggerDetails.newStatus === 'SUCCEEDED'
              ? 'Successfully Approved'
              : 'Successfully Rejected',
          type: 'success',
        });
      })
      .catch((err) => {
        addToastMessage({
          header: 'Error Sending Request',
          description: `There was an issue submitting your request. ${err.message}`,
          type: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return [loading, sendApprovalDecision];
};
